import type { SupplierIndustry } from '@tandemone/types'
import { Fragment } from 'react'

import { SUPPLIER_INDUSTRY_OPTIONS } from '@/domains/supplier-onboarding'

import { ProfileEmpty } from './profile-empty'
import { ProfileSection } from './profile-section'

export function ProfileIndustries({
  companyName,
  rows
}: {
  companyName: string
  rows: SupplierIndustry[]
}) {
  return (
    <ProfileSection title={`Industries Served by ${companyName}`}>
      {rows.length === 0 ? (
        <ProfileEmpty message='No industries listed.' />
      ) : (
        <div className='grid grid-cols-[1fr_auto] [&>*]:py-1.5 [&>*:nth-child(n+3)]:border-t [&>*:nth-child(n+3)]:border-border'>
          {rows
            .slice()
            .sort((left, right) => right.yearsInBusiness - left.yearsInBusiness)
            .map(row => (
              <Fragment key={row.id}>
                <span className='flex items-center text-sm text-foreground'>
                  {SUPPLIER_INDUSTRY_OPTIONS[row.industry].label}
                </span>
                <span className='flex items-center justify-end pl-4 text-xs tabular-nums text-ink-soft'>
                  {row.yearsInBusiness} yrs
                </span>
              </Fragment>
            ))}
        </div>
      )}
    </ProfileSection>
  )
}
